module.exports = __webpack_public_path__ + "static/media/COXS BAZAR.32162f64.png";